import { render } from "./ViewProfile.vue?vue&type=template&id=5297cc34&scoped=true"
const script = {}

import "./ViewProfile.vue?vue&type=style&index=0&id=5297cc34&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5297cc34"]])

export default __exports__